angular
	.module('AutoPrequal')
	.controller('mainCtrl', mainCtrl);

mainCtrl.$inject = ['$scope', '$rootScope', 'ScrollFactory', '$timeout', '$window'];

/**
 * Due to the 1 page design, tab and alt-tab is not great for accessbility and the following troubles has been noted as follows
 * 1. If user returns to the first section (welcome), user has to tab through the entire app again to return the the last section git#364
 *    Soln; A helper link has been added to the bottom of each section that allows user to skip last section. 
 *          Button is styled akin to the 'Skip to main content' button in the header. (they only show up when focused on)
 * 2. The user cannot easly access the header/footer of the app. They must alt-tab/tab through the entire app before they can reach these sections. git#365
 *    Soln; Alt tab no longer lets the user return to the previous section. Instead it will jump directly to the header. Similarly, tabbing out of the header
 *          will jump directly back to the current section the user is on. To let the user return to the previous section, a helper link has been added 
 *          to the top of each section that allows user to return to the previous section. Button is styled akin to the 'Skip to main content' button in the header.
 */
function mainCtrl($scope, $rootScope, ScrollFactory, $timeout, $window) {
	$rootScope.isLoaded = true;

	$scope.focusTop = function () {
		if ($rootScope.progressCurrent) {
			$('#progressLabel').focus();
		} else {
			$('#skipToContent').focus();
		}
	}

	$scope.gotoCurrentSection = function () {
		if ($rootScope.currentStep != 'welcome') {
			var position = $('section.' + $rootScope.currentStep).offset().top - 70;
			$('section.' + $rootScope.currentStep).find('h1').first()[0].focus();
			$('.container-right').scrollTop(position);
		}
	}

	$scope.gotoPrevSection = function (stepName) {
		ScrollFactory.goToStep(ScrollFactory.getPrevStep(stepName));
	}

	$scope.getLastStep = ScrollFactory.getLastStep;

	var container = $('.container-right');
	container.on('scroll', _.debounce(function () {
		if ($window.innerWidth > 640) {
			$timeout.cancel(theTimeout)
			var theTimeout = $timeout(function () {
				$('ng-include').each(function (i, raw) {
					if (isVisible(raw, false)) {
						$(raw).css("opacity", 1);
						if ($rootScope.currentStep !== $(raw).attr('name') && !$rootScope.scrolling) {
							//debounce will cause this to sometimes fire after a state change, causing currentStep to incorrectly be the previous step. Need to check that currentStep isn't a state value first
							if ($rootScope.currentStep !== "error" && $rootScope.currentStep !== "maintenance")
								$rootScope.currentStep = $(raw).attr('name');
							ScrollFactory.goToStep($(raw).attr('name'), 500)
						}
					}
					else {
						$(raw).css("opacity", 0.2);
					}

				})
			}, 100)

		}
	}, 100, { 'leading': false, 'trailing': true }));

	function isVisible(element, fullyInView) {
		var rect = element.getBoundingClientRect();
		var headerHeight = $('header').height();
		var pageTop = $(window).scrollTop() + headerHeight;
		var pageBottom = pageTop + $('.container-right').height();

		var containerHeight = $('.container-right').height();
		var elementTop = $(element).offset().top;
		var elementBottom = elementTop + $(element).height();
		if (fullyInView === true) {
			return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
		} else {
			return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
		}
	}
}
